import styled from "styled-components";

export let LoginRegisterTitle = styled.span`
  background-color: ${global.config.colors.primaryUltraLight};
`;